import React from 'react'
import Header from '../../components/generals/header'
import stylesIndex from './../../css/Index.module.css'
import { NavLink } from 'react-router-dom'
import store from '../../reducer/store'
import styles from '../../css/reports/Reports.module.css'
import { useTranslation } from 'react-i18next'

export default function Reports () {
  const { t } = useTranslation('reports')
  const { user } = store.getState()
  const role = user.roles

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <p className={styles.title}>{t('label1')}</p>
        <ul className={styles.listReports}>
          {role?.reportsPage?.lastLocationReport && <li>
            <NavLink to="/mdm/reports/devices-location-report" className={styles.link}>
              <i className="fa fa-file-signature" aria-hidden="true"></i>
              <p>{t('label2')}</p>
            </NavLink>
            <p className={styles.description}>{t('label3')}</p>
          </li>}
          {role?.reportsPage?.missingDevicesReport && <li>
            <NavLink to="/mdm/reports/missing-devices-report" className={styles.link}>
              <i className="fa fa-file-signature" aria-hidden="true"></i>
              <p>{t('label4')}</p>
            </NavLink>
            <p className={styles.description}>{t('label5')}</p>
          </li>}
          {role?.reportsPage?.reportedDevicesReport && <li>
            <NavLink to="/mdm/reports/reported-devices-report" className={styles.link}>
              <i className="fa fa-file-signature" aria-hidden="true"></i>
              <p>{t('label6')}</p>
            </NavLink>
            <p className={styles.description}>{t('label7')}</p>
          </li>}
          {role?.reportsPage?.devicesReport && <li>
            <NavLink to="/mdm/reports/devices-report" className={styles.link}>
              <i className="fa fa-file-signature" aria-hidden="true"></i>
              <p>{t('label8')}</p>
            </NavLink>
            <p className={styles.description}>{t('label9')}</p>
          </li>}
          {role?.reportsPage?.deviceActivationReport && <li>
            <NavLink to="/mdm/reports/devices-activation-report" className={styles.link}>
              <i className="fa fa-file-signature" aria-hidden="true"></i>
              <p>{t('label10')}</p>
            </NavLink>
            <p className={styles.description}>{t('label11')}</p>
          </li>}
          {role?.reportsPage?.usersReport && <li>
            <NavLink to="/mdm/reports/users-report" className={styles.link}>
              <i className="fa fa-file-signature" aria-hidden="true"></i>
              <p>{t('label12')}</p>
            </NavLink>
            <p className={styles.description}>{t('label13')}</p>
          </li>}
          {role?.reportsPage?.geofencesReport && <li>
            <NavLink to="/mdm/reports/geofences-report" className={styles.link}>
              <i className="fa fa-file-signature" aria-hidden="true"></i>
              <p>{t('label14')}</p>
            </NavLink>
            <p className={styles.description}>{t('label15')}</p>
          </li>}
          {role?.reportsPage?.deviceHardwareReport && <li>
            <NavLink to="/mdm/reports/device-hardware-report" className={styles.link}>
              <i className="fa fa-file-signature" aria-hidden="true"></i>
              <p>{t('label16')}</p>
            </NavLink>
            <p className={styles.description}>{t('label17')}</p>
          </li>}
          {role?.reportsPage?.appsReport && <li>
            <NavLink to="/mdm/reports/apps-report" className={styles.link}>
              <i className="fa fa-file-signature" aria-hidden="true"></i>
              <p>{t('label18')}</p>
            </NavLink>
            <p className={styles.description}>{t('label19')}</p>
          </li>}
        </ul>
      </div>
    </div>
  )
}

// {role?.reportsPage?.deviceApplicationsReport && <li>
//   <NavLink /* to="/mdm/reports" */ className={styles.link}>
//       <i className="fa fa-file-signature" aria-hidden="true"></i>
//       <p /* className="colorLeters" */>Reporte de aplicaciones de los dispositivos</p>
//   </NavLink>
// </li>}
